import Api from "@/api/Api";

export const BASE_PATH = process.env.NEXT_PUBLIC_API_BASE_URL || "";

const options = {
  basePath: BASE_PATH,
};

const ApiClient = new Api(options);

export default ApiClient;
